import axios from 'axios';
(function () {
  angular.module('leanlaw').directive('llDemoToggle', DemoToggleDirective);
  DemoToggleDirective.$inject = ['userService', 'leanLawAuth', 'alerts'];
  function DemoToggleDirective(userService, leanLawAuth, alerts) {
    return {
      restrict: 'EA',
      template: require('./views/demo-toggle.html'),
      scope: {
        me: '='
      },
      link: function (scope, element, attrs) {
        scope.shouldShowDemoToggle = function () {
          if (!scope.me || !scope.me.company) {
            return false;
          }
          const company = scope.me.company;
          // Hide if QuickBooks is currently connected
          const isQBConnected = company.integration && company.integration.quickbooks;
          return !isQBConnected;
        };
        scope.getDemoMode = function () {
          return scope.me && scope.me.company && scope.me.company.settings ? scope.me.company.settings.demoMode || false : false;
        };
        scope.toggleDemoMode = function () {
          const currentMode = scope.getDemoMode();
          const newMode = !currentMode;

          // Update company settings if available
          if (scope.me && scope.me.company && scope.me.company.id) {
            const fullUrl = `${leanLawAuth.domain}/v1/companies/${scope.me.company.id}/settings/demo-mode`;
            axios({
              method: 'PUT',
              url: fullUrl,
              data: {
                DemoMode: newMode
              }
            }).then(function (response) {
              // Reset user service cache to ensure fresh data on next fetch
              userService.reset();

              // Refetch user data to get updated settings
              userService.me().then(function (updatedMe) {
                // Update the scope with fresh data
                scope.me = updatedMe;
                if (newMode) {
                  alerts.info('Demo mode is now active. Invoice creation will use sample data for testing purposes.');
                } else {
                  alerts.info('Demo mode is now disabled. Invoice creation will use real client data.');
                }
              }).catch(function (error) {
                console.error('Failed to refetch user data:', error);

                // Still show success message since API call succeeded
                if (newMode) {
                  alerts.info('Demo mode is now active. Invoice creation will use sample data for testing purposes.');
                } else {
                  alerts.info('Demo mode is now disabled. Invoice creation will use real client data.');
                }
              });
            }).catch(function (error) {
              alerts.alert({
                title: 'Error',
                message: 'Failed to update demo mode setting. Please try again.',
                type: 'error'
              });
            });
          } else {
            alerts.error('Unable to update demo mode: Company information not available.');
          }
        };
      }
    };
  }
})();